import { ApiError } from '@/shared/api/api-client/api-error';
import { API_AUTH_RESET_PASSWORD } from '@/shared/constants/bff-endpoints';


export interface ResetPasswordPayload {
    key: string;
    password: string;
}


export async function resetPassword (payload: ResetPasswordPayload): Promise<{ ok: boolean }> {
    const res = await fetch(API_AUTH_RESET_PASSWORD, {
        method : 'POST',
        headers: { 'Content-Type': 'application/json' },
        body   : JSON.stringify(payload),
    });

    if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new ApiError(res.status, data);
    }

    return res;
}
